import config from 'config'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components'
import Button from 'srcReact/components/common2/Button'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Modal from 'srcReact/components/common2/Modal'
import Spinner from 'srcReact/components/common2/Spinner'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { loginActions } from 'srcReact/LoginPage'
import { organizationActions } from 'srcReact/OrganizationPage'
import { settingsActions } from 'srcReact/Settings/action'
import styles from './styles.module.scss'

function CloseAccountModal({ showModal, modalType, orgName, hideModal }) {
  const dispatch = useDispatch()
  const [deactivateSuccess, setDeactivateSuccess] = useState(false)
  const {
    common: { isNative },
    organization: { organization_list },
    settings: {
      deactivateAccData: { loading, error, data, emailSentMessage }
    }
  } = useSelector((state) => state)
  const { t } = useTranslation()
  useEffect(() => {
    return () => {
      dispatch(settingsActions.clearDeactivatedData())
    }
  }, [])

  useEffect(() => {
    if (deactivateSuccess) {
      if (isNative) {
        window.location = `${config.webUrl}/deactivate/account`
        return
      }
      if (organization_list && organization_list.items && organization_list.items.length === 1) {
        dispatch(loginActions.userLogout())
      } else {
        dispatch(organizationActions.getByUser(appConstantSettings.ORG_LIST_QTY, true))
      }
    }
  }, [deactivateSuccess])

  useEffect(() => {
    if (data) {
      if (data.deactivated === 1) {
        setDeactivateSuccess(true)
      } else {
        setDeactivateSuccess(false)
        dispatch(commonActions.setTransferRoleData(data))
        hideModal()
      }
    }
  }, [data])

  const deactivateAccount = () => {
    let orgId = getCurrentOrgId()
    if (isNative) {
      orgId = urlSearchParams('organization_id')
    }
    dispatch(settingsActions.deactivateAccount(orgId))
  }

  const deleteAccount = () => {
    let orgId = getCurrentOrgId()
    if (isNative) {
      orgId = urlSearchParams('organization_id')
    }
    dispatch(settingsActions.requestDeleteAccount(orgId))
  }

  return (
    <Modal
      isOpen={showModal}
      handleClose={hideModal}
      closeOnDocumentClick={true}
      title={
        modalType === 'deactivate'
          ? t('account_settings.sidebar.deactivateAcc')
          : modalType === 'delete'
          ? t('account_settings.sidebar.deleteAcc')
          : ''
      }
      subTitle={
        !deactivateSuccess
          ? modalType === 'deactivate'
            ? t('account_settings.sidebar.deactivateWarning', { orgName })
            : modalType === 'delete'
            ? t('account_settings.sidebar.deleteWarning', { orgName })
            : ''
          : ''
      }>
      {loading && <Spinner />}
      {error ? (
        <ErrorMessage html={error} className={styles.error} />
      ) : emailSentMessage ? (
        <SuccessMessage html={emailSentMessage} className={styles.success} />
      ) : deactivateSuccess ? (
        <React.Fragment>
          <SuccessMessage
            html={t('account_settings.sidebar.deactivateSuccessMessage', { orgName: orgName })}
            className={styles.success}
          />
        </React.Fragment>
      ) : (
        <div className={styles.modalButtons}>
          <Button style='secondary' handleClick={hideModal} text={t('global.cancel')} />
          <Button handleClick={modalType === 'deactivate' ? deactivateAccount : deleteAccount} text={t('global.yes')} />
        </div>
      )}
    </Modal>
  )
}

export default CloseAccountModal
